export default __webpack_public_path__ + "static/HelveticaNeue-Medium-1fa0ad2e4b2e2122476ae6cc7db50e4f.woff";